const STEPPER_PROCESS = 'stepper-process';

export { STEPPER_PROCESS };
